export const BRAND = {
  // Core navy
  navy: "#00357a",
  navyDark: "#001f4d",
  navyDeep: "#000e24",
  navyMid: "#00245c",
  navyLight: "#0a4a9e",

  // Gold — warmer, more premium
  gold: "#c9a96e",
  goldLight: "#dfc08a",
  goldDark: "#9e7a3a",
  goldPale: "#fdf6eb",

  // Neutrals
  white: "#ffffff",
  offWhite: "#f7f9fc",
  lightGray: "#edf1f8",
  midGray: "#c4cdd9",
  subtleGray: "#f0f3f9",

  // Text
  textDark: "#0d1b2e",
  textMid: "#4a5568",
  textLight: "#8896a8",

  // Functional
  success: "#10b981",
  info: "#0ea5e9",
};
